export * from "./QuizResultShortAnswer";
